// import React, { Component, createRef } from "react";
// import { isMobileApp } from "../../../actions/Util";
// import NewButton from "./NewButton";
// import Icon from "./Icon";
// import Input from "./Input";
// import NewImageButton from "./NewImageButton";

// class ViewPage extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       showMobileOptions: false
//     };

//     this.floatingMenuRef = createRef();
//   }

//   componentDidMount() {
//     document.addEventListener(
//       "mousedown",
//       this.handleClickOutside
//     );
//   }

//   componentWillUnmount() {
//     document.removeEventListener(
//       "mousedown",
//       this.handleClickOutside
//     );
//   }

//   handleClickOutside = (event) => {
//     if (
//       this.floatingMenuRef.current &&
//       !this.floatingMenuRef.current.contains(
//         event.target
//       )
//     ) {
//       this.setState({
//         showMobileOptions: false
//       });
//     }
//   };

//   getStyles = () => {
//     return {
//       container: {
//         display: "flex",
//         flexDirection: "column",
//         position: "relative",
//         height: "100vh",
//         paddingBottom: "28px",
//         overflow: "hidden",
//         backgroundColor: "#ffffff"
//       },

//       headerWrapper: {
//         position: "relative",
//         flexShrink: 0,
//         borderBottom: "1px solid #eee",
//         backgroundSize: "cover",
//         backgroundPosition: "left"
//       },

// header: {
//   padding: isMobileApp()
//     ? "20px 16px 12px"
//     : "15px 16px 8px",
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center", // change from flex-start
//   position: "relative",
//   zIndex: 10,
//   color: "#ffffff",

//   ...(isMobileApp()
//     ? {
//         background:
//           "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
//       }
//     : {})
// },

//       headerWithNoTabs: {
//         paddingBottom: "8px"
//       },

// leftSection: {
//   display: "flex",
//   gap: "12px",
//   alignItems: "center", // always center
//   flex: 1,
//   minWidth: 0
// },
//       backButton: {
//         width: "28px",
//         height: "28px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         cursor: "pointer",
//         flexShrink: 0
//       },

//       avatar: {
//         width: "56px",
//         height: "56px",
//         borderRadius: "8px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         color: "#ffffff",
//         fontSize: "24px",
//         fontWeight: "bold",
//         boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
//         background:
//           "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
//         textTransform: "capitalize"
//       },

//     nameWrapper: {
//   display: "flex",
//   flexDirection: "column",
//   flex: 1,
//   minWidth: 0,
//   justifyContent: "center"
// },


//     mobileTitle: {
//   fontSize: "20px",
//   fontWeight: "bold",
//   whiteSpace: "nowrap",
//   overflow: "hidden",
//   textOverflow: "ellipsis",
//   margin: 0,
//   maxWidth: "100%"
// },

// desktopTitle: {
//   fontSize: "21px",
//   fontWeight: "bold",
//   color: "#1f2937",
//   margin: 0,
//   whiteSpace: "nowrap",
//   overflow: "hidden",
//   textOverflow: "ellipsis",
//   maxWidth: "100%"
// },

//       description: {
//         color: "#6b7280"
//       },

//      rightSection: {
//   display: "flex",
//   gap: "20px",
//   alignItems: "center",
//   flexShrink: 0
// },

//       buttonGroup: {
//         display: "flex",
//         gap: "8px"
//       },

//       removeButton: {
//         width: "28px",
//         height: "28px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         cursor: "pointer",
//         flexShrink: 0,
//         color: "#6b7280"
//       },

//       tabsWrapper: {
//         padding: "0 16px"
//       },

//       customHeader: {
//         padding: "0 16px"
//       },

//       contentWrapper: {
//         flex: 1,
//         display: "flex",
//         flexDirection: "column",
//         overflow: "hidden"
//       },

//       content: {
//         flex: 1,
//         overflowY: "auto"
//       },

//       overlay: {
//         position: "fixed",
//         inset: 0,
//         background: "rgba(0,0,0,0.7)",
//         zIndex: 10
//       },

//       floatingWrapper: {
//         position: "fixed",
//         bottom: "20px",
//         right: "24px",
//         zIndex: 20
//       },

//       floatingMenu: {
//         position: "absolute",
//         bottom: "64px",
//         right: 0,
//         marginBottom: "8px",
//         overflow: "hidden"
//       },

//       floatingMenuInner: {
//         padding: "8px 0",
//         boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
//         backgroundColor: "#ffffff",
//         borderRadius: "12px",
//         minWidth: "220px"
//       },

//       floatingMenuItems: {
//         display: "flex",
//         flexDirection: "column"
//       },

//       floatingMenuItem: {
//         width: "100%",
//         display: "flex",
//         justifyContent: "flex-end",
//         alignItems: "center",
//         padding: "12px 16px",
//         cursor: "pointer",
//         gap: "16px"
//       },

//       floatingMenuLabel: {
//         fontWeight: 600,
//         whiteSpace: "nowrap"
//       },

//       floatingMenuIconWrapper: {
//         flexShrink: 0
//       }
//     };
//   };

//   renderIconButtons = () => {
//     const styles = this.getStyles();
//     const { iconButtons = [] } = this.props;

//     console.log("iconbuttons",iconButtons);
//     return iconButtons.map((button, index) => {
//       if (
//         Object.prototype.hasOwnProperty.call(
//           button,
//           "type"
//         ) &&
//         button.type === "button"
//       ) {
//         return (
//           <div
//             key={index}
//             style={styles.buttonGroup}
//           >
//             <NewButton
//               type={
//                 Object.prototype.hasOwnProperty.call(
//                   button,
//                   "buttonType"
//                 )
//                   ? button.buttonType
//                   : "primary"
//               }
//               iconType={
//                 Object.prototype.hasOwnProperty.call(
//                   button,
//                   "iconType"
//                 )
//                   ? button.iconType
//                   : undefined
//               }
//               onClick={
//                 Object.prototype.hasOwnProperty.call(
//                   button,
//                   "onClick"
//                 )
//                   ? button.onClick
//                   : undefined
//               }
//               disabled={
//                 Object.prototype.hasOwnProperty.call(
//                   button,
//                   "disabled"
//                 )
//                   ? button.disabled
//                   : false
//               }
//               className={
//                 Object.prototype.hasOwnProperty.call(
//                   button,
//                   "className"
//                 )
//                   ? button.className
//                   : ""
//               }
//             >
//               {button.label}
//             </NewButton>

//             {Object.prototype.hasOwnProperty.call(
//               button,
//               "hasSelect"
//             ) &&
//               button.hasSelect &&
//               Object.prototype.hasOwnProperty.call(
//                 button,
//                 "selectProps"
//               ) && (
//              <Input
//   type="select"
//   onChange={
//     button.selectProps.onChange
//   }
//   value={
//     button.selectProps.value
//   }
//   disabled={
//     button.selectProps.disabled
//   }
// >
//   {button.selectProps.options &&
//     button.selectProps.options.map(
//       (option, optionIndex) => (
//         <option
//           key={optionIndex}
//           value={option.value}
//         >
//           {option.label}
//         </option>
//       )
//     )}
// </Input>
//               )}
//           </div>
//         );
//       }


//       return (
//         <div
//           key={index}
//        style={{ ...styles.buttonGroup, color: "#000000" }}
          
//         >
          
        
//         <NewImageButton
//   onClick={
//     Object.prototype.hasOwnProperty.call(
//       button,
//       "onClick"
//     )
//       ? button.onClick
//       : undefined
//   }
//   // label={
//   //   Object.prototype.hasOwnProperty.call(
//   //     button,
//   //     "label"
//   //   )
//   //     ? button.label
//   //     : ""
//   // }
//    icon={button.icon}
// />

//           {Object.prototype.hasOwnProperty.call(
//             button,
//             "hasSelect"
//           ) &&
//             button.hasSelect &&
//             Object.prototype.hasOwnProperty.call(
//               button,
//               "selectProps"
//             ) && (
//             <Input
//   type="select"
//   onChange={
//     button.selectProps.onChange
//   }
//   value={
//     button.selectProps.value
//   }
//   disabled={
//     button.selectProps.disabled
//   }
// >
//   {button.selectProps.options &&
//     button.selectProps.options.map(
//       (option, optionIndex) => (
//         <option
//           key={optionIndex}
//           value={option.value}
//         >
//           {option.label}
//         </option>
//       )
//     )}
// </Input>
//             )}
//         </div>
//       );
//     });
//   };

//   getButtonColors = (button, index) => {
//     const colors = [
//       { bg: "#ef4444", text: "#ffffff" },
//       { bg: "#8b5cf6", text: "#ffffff" },
//       { bg: "#10b981", text: "#ffffff" },
//       { bg: "#f59e0b", text: "#ffffff" },
//       { bg: "#3b82f6", text: "#ffffff" },
//       { bg: "#6366f1", text: "#ffffff" },
//       { bg: "#ec4899", text: "#ffffff" },
//       { bg: "#14b8a6", text: "#ffffff" }
//     ];

//     if (
//       Object.prototype.hasOwnProperty.call(
//         button,
//         "label"
//       ) &&
//       (button.label
//         .toLowerCase()
//         .includes("delete") ||
//         button.label
//           .toLowerCase()
//           .includes("remove"))
//     ) {
//       return {
//         bg: "#dc2626",
//         text: "#ffffff"
//       };
//     }

//     if (
//       Object.prototype.hasOwnProperty.call(
//         button,
//         "label"
//       ) &&
//       button.label.toLowerCase().includes("save")
//     ) {
//       return {
//         bg: "#10b981",
//         text: "#ffffff"
//       };
//     }

//     if (
//       Object.prototype.hasOwnProperty.call(
//         button,
//         "label"
//       ) &&
//       button.label
//         .toLowerCase()
//         .includes("cancel")
//     ) {
//       return {
//         bg: "#6b7280",
//         text: "#ffffff"
//       };
//     }

//     return colors[index % colors.length];
//   };

//   renderFloatingMenuItems = () => {
//     const styles = this.getStyles();
//     const { iconButtons = [] } = this.props;

//     return (
//       <div style={styles.floatingMenuItems}>
//         {iconButtons.map((button, index) => {
//           const colors = this.getButtonColors(
//             button,
//             index
//           );

//           return (
//             <div
//               key={
//                 Object.prototype.hasOwnProperty.call(
//                   button,
//                   "label"
//                 )
//                   ? button.label
//                   : index
//               }
//               style={styles.floatingMenuItem}
//               onClick={() => {
//                 if (
//                   Object.prototype.hasOwnProperty.call(
//                     button,
//                     "onClick"
//                   ) &&
//                   typeof button.onClick ===
//                     "function"
//                 ) {
//                   button.onClick();
//                 }

//                 this.setState({
//                   showMobileOptions: false
//                 });
//               }}
//             >
//               <span
//                 style={{
//                   ...styles.floatingMenuLabel,
//                   color: colors.text
//                 }}
//               >
//                 {Object.prototype.hasOwnProperty.call(
//                   button,
//                   "label"
//                 )
//                   ? button.label
//                   : ""}
//               </span>

//               <div
//                 style={
//                   styles.floatingMenuIconWrapper
//                 }
//               >
//                 <NewImageButton
//   onClick={() => {
//     if (
//       Object.prototype.hasOwnProperty.call(
//         button,
//         "onClick"
//       ) &&
//       typeof button.onClick === "function"
//     ) {
//       button.onClick();
//     }

//     this.setState({
//       showMobileOptions: false
//     });
//   }}
//   // label={
//   //   Object.prototype.hasOwnProperty.call(
//   //     button,
//   //     "label"
//   //   )
//   //     ? button.label
//   //     : ""
//   // }
//   icon={button.icon}
// />
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   render() {
//     const styles = this.getStyles();

//     const {
//       name,
//       description,
//       highLightFirstLetter,
//       handleEditBtnClick,
//       handleDeleteBtnClick,
//       handleRemoveBtnClick,
//       children,
//       moreBtn,
//       tabs,
//       customHeader,
//       backgroundColor,
//       iconButtons = []
//     } = this.props;

//     const { showMobileOptions } = this.state;

//     return (
//       <div style={styles.container}>
//         {/* Header */}
//         <div style={styles.headerWrapper}>
//           {!customHeader && (
//             <div
//               style={{
//                 ...styles.header,
//                 ...(!tabs
//                   ? styles.headerWithNoTabs
//                   : {})
//               }}
//             >
//               {/* Left */}
//               <div style={styles.leftSection}>
//                 {handleRemoveBtnClick &&
//                   isMobileApp() &&
//                   !iconButtons.find(
//                     (btn) =>
//                       Object.prototype.hasOwnProperty.call(
//                         btn,
//                         "label"
//                       ) &&
//                       btn.label.includes("Remove")
//                   ) && (
//                     <span
//                       style={styles.backButton}
//                       onClick={
//                         handleRemoveBtnClick
//                       }
//                     >
//                       <Icon type="back" />
//                     </span>
//                   )}

//                 {highLightFirstLetter && (
//                   <div style={styles.avatar}>
//                     {highLightFirstLetter}
//                   </div>
//                 )}

//                 {name && (
//                   <div style={styles.nameWrapper}>
//                     {isMobileApp() ? (
//                       <h2
//                         style={
//                           styles.mobileTitle
//                         }
//                       >
//                         {name}
//                       </h2>
//                     ) : (
//                       <h1
//                         style={
//                           styles.desktopTitle
//                         }
//                       >
//                         {name}
//                       </h1>
//                     )}

//                     {description && (
//                       <div
//                         style={
//                           styles.description
//                         }
//                       >
//                         {description}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {/* Right */}
//               <div style={styles.rightSection}>
//                 {!isMobileApp() &&
//                   this.renderIconButtons()}

//                 {handleEditBtnClick &&
//                   !iconButtons.find(
//                     (btn) =>
//                       Object.prototype.hasOwnProperty.call(
//                         btn,
//                         "label"
//                       ) &&
//                       btn.label.includes("Edit")
//                   ) && (
//                   <NewImageButton
//   onClick={handleEditBtnClick}
//   label="Edit"
//   type="edit"
// />
//                   )}

//                 {moreBtn && <span>{moreBtn}</span>}

//                 {handleDeleteBtnClick &&
//                   !iconButtons.find(
//                     (btn) =>
//                       Object.prototype.hasOwnProperty.call(
//                         btn,
//                         "label"
//                       ) &&
//                       btn.label.includes("Delete")
//                   ) && (
//                  <NewImageButton
//   onClick={handleDeleteBtnClick}
//   label="Delete"
//    type="delete"
// />
//                   )}

//                 {handleRemoveBtnClick &&
//                   !isMobileApp() &&
//                   !iconButtons.find(
//                     (btn) =>
//                       Object.prototype.hasOwnProperty.call(
//                         btn,
//                         "label"
//                       ) &&
//                       btn.label.includes("Remove")
//                   ) && (
//                     <span
//                       style={
//                         styles.removeButton
//                       }
//                       onClick={
//                         handleRemoveBtnClick
//                       }
//                     >
//                       <Icon type="remove" />
//                     </span>
//                   )}
//               </div>
//             </div>
//           )}

//           {customHeader && (
//             <span style={styles.customHeader}>
//               {customHeader}
//             </span>
//           )}

//           {tabs && (
//             <div style={styles.tabsWrapper}>
//               {tabs}
//             </div>
//           )}
//         </div>

//         {/* Main Content */}
//         <div style={styles.contentWrapper}>
//           <div
//             style={{
//               ...styles.content,
//               ...(backgroundColor
//                 ? {
//                     background:
//                       backgroundColor
//                   }
//                 : {})
//             }}
//           >
//             {children}
//           </div>
//         </div>

//         {/* Mobile Floating Menu */}
//         {isMobileApp() &&
//           iconButtons.length > 0 && (
//             <>
//               {showMobileOptions && (
//                 <div
//                   style={styles.overlay}
//                   onClick={() =>
//                     this.setState({
//                       showMobileOptions: false
//                     })
//                   }
//                 />
//               )}

//               <div
//                 style={styles.floatingWrapper}
//                 ref={this.floatingMenuRef}
//               >
//                 {showMobileOptions && (
//                   <div
//                     style={styles.floatingMenu}
//                   >
//                     <div
//                       style={
//                         styles.floatingMenuInner
//                       }
//                     >
//                       {this.renderFloatingMenuItems()}
//                     </div>
//                   </div>
//                 )}

//             <NewImageButton
//   onClick={() =>
//     this.setState({
//       showMobileOptions:
//         !showMobileOptions
//     })
//   }
//   icon={
//     showMobileOptions
//       ? "remove"
//       : "option"
//   }
// />
//               </div>
//             </>
//           )}
//       </div>
//     );
//   }
// }

// export default ViewPage;

import React, { Component } from "react";
import { isMobileApp } from "../../../actions/Util";
import NewButton from "./NewButton";
import Icon from "./Icon";
import Input from "./Input";
import NewImageButton from "./NewImageButton";
import ActionSheet from "./ActionSheet";

class ViewPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMobileOptions: false
    };
  }

  getStyles = () => {
    return {
      container: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        height: "100vh",
        paddingBottom: "28px",
        overflow: "hidden",
        backgroundColor: "#ffffff"
      },

      headerWrapper: {
        position: "relative",
        flexShrink: 0,
        borderBottom: "1px solid #eee",
        backgroundSize: "cover",
        backgroundPosition: "left"
      },

      header: {
        padding: isMobileApp()
          ? "8px 12px 8px 4px"
          : "15px 16px 8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center", // change from flex-start
        gap: isMobileApp() ? "8px" : "16px",
        position: "relative",
        zIndex: 10,
        // phones: flat white app bar, same as every other phone screen
        color: isMobileApp() ? "#111827" : "#ffffff",

        ...(isMobileApp()
          ? {
            minHeight: "56px",
            background: "#ffffff"
          }
          : {})
      },

      headerWithNoTabs: {
        paddingBottom: "8px"
      },

      leftSection: {
        display: "flex",
        gap: "12px",
        alignItems: "center", // always center
        flex: "1 1 auto",
        minWidth: 0,
        overflow: "hidden"
      },
      backButton: {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        flexShrink: 0
      },

      avatar: {
        width: "56px",
        height: "56px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ffffff",
        fontSize: "24px",
        fontWeight: "bold",
        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        background:
          "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
        textTransform: "capitalize"
      },

      nameWrapper: {
        display: "flex",
        flexDirection: "column",  // Stack children vertically
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
        justifyContent: "center",
        gap: "2px"  // Small gap between title and description
      },


      mobileTitle: {
        fontSize: "18px",
        fontWeight: 600,
        color: "#111827",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        margin: 0,
        minWidth: 0,
        position: "static",
        textTransform: "none",
        letterSpacing: "normal"
      },

      desktopTitle: {
        fontSize: "21px",
        fontWeight: "bold",
        color: "#1f2937",
        margin: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        minWidth: 0,
        position: "static",
        textTransform: "none",
        letterSpacing: "normal"
      },

      description: {
        color: "#6b7280",
        // marginTop: "4px",
         padding: "0 16px 8px 16px",  // Add some space from the title
        // wordBreak: "break-word",  // Handle long text
        // fontSize: "14px"  // Optional: adjust size
      },

      rightSection: {
        display: "flex",
        gap: "20px",
        alignItems: "center",
        flexShrink: 0
      },

      buttonGroup: {
        display: "flex",
        gap: "8px"
      },

      removeButton: {
        width: "28px",
        height: "28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        flexShrink: 0,
        color: "#6b7280"
      },

      tabsWrapper: {
        padding: "0 16px"
      },

      customHeader: {
        padding: "0 16px"
      },

      contentWrapper: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      },

      content: {
        flex: 1,
        overflowY: "auto"
      },

      floatingWrapper: {
        position: "fixed",
        bottom: "20px",
        right: "24px",
        zIndex: 20
      }
    };
  };

  renderIconButtons = () => {
    const styles = this.getStyles();
    const { iconButtons = [] } = this.props;

    console.log("iconbuttons", iconButtons);
    return iconButtons.map((button, index) => {
      if (
        Object.prototype.hasOwnProperty.call(
          button,
          "type"
        ) &&
        button.type === "button"
      ) {
        return (
          <div
            key={index}
            style={styles.buttonGroup}
          >
            <NewButton
              type={
                Object.prototype.hasOwnProperty.call(
                  button,
                  "buttonType"
                )
                  ? button.buttonType
                  : "primary"
              }
              iconType={
                Object.prototype.hasOwnProperty.call(
                  button,
                  "iconType"
                )
                  ? button.iconType
                  : undefined
              }
              onClick={
                Object.prototype.hasOwnProperty.call(
                  button,
                  "onClick"
                )
                  ? button.onClick
                  : undefined
              }
              disabled={
                Object.prototype.hasOwnProperty.call(
                  button,
                  "disabled"
                )
                  ? button.disabled
                  : false
              }
              className={
                Object.prototype.hasOwnProperty.call(
                  button,
                  "className"
                )
                  ? button.className
                  : ""
              }
            >
              {button.label}
            </NewButton>

            {Object.prototype.hasOwnProperty.call(
              button,
              "hasSelect"
            ) &&
              button.hasSelect &&
              Object.prototype.hasOwnProperty.call(
                button,
                "selectProps"
              ) && (
                <Input
                  type="select"
                  onChange={
                    button.selectProps.onChange
                  }
                  value={
                    button.selectProps.value
                  }
                  disabled={
                    button.selectProps.disabled
                  }
                >
                  {button.selectProps.options &&
                    button.selectProps.options.map(
                      (option, optionIndex) => (
                        <option
                          key={optionIndex}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      )
                    )}
                </Input>
              )}
          </div>
        );
      }


      return (
        <div
          key={index}
          style={{ ...styles.buttonGroup, color: "#000000" }}

        >


          <NewImageButton
            onClick={
              Object.prototype.hasOwnProperty.call(
                button,
                "onClick"
              )
                ? button.onClick
                : undefined
            }
            // label={
            //   Object.prototype.hasOwnProperty.call(
            //     button,
            //     "label"
            //   )
            //     ? button.label
            //     : ""
            // }
            icon={button.icon}
          />

          {Object.prototype.hasOwnProperty.call(
            button,
            "hasSelect"
          ) &&
            button.hasSelect &&
            Object.prototype.hasOwnProperty.call(
              button,
              "selectProps"
            ) && (
              <Input
                type="select"
                onChange={
                  button.selectProps.onChange
                }
                value={
                  button.selectProps.value
                }
                disabled={
                  button.selectProps.disabled
                }
              >
                {button.selectProps.options &&
                  button.selectProps.options.map(
                    (option, optionIndex) => (
                      <option
                        key={optionIndex}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    )
                  )}
              </Input>
            )}
        </div>
      );
    });
  };

render() {
  const styles = this.getStyles();

  const {
    name,
    description,
    highLightFirstLetter,
    handleEditBtnClick,
    handleDeleteBtnClick,
    handleRemoveBtnClick,
    children,
    moreBtn,
    tabs,
    customHeader,
    backgroundColor,
    iconButtons = []
  } = this.props;

  const { showMobileOptions } = this.state;

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.headerWrapper}>
        {!customHeader && (
          <div
            style={{
              ...styles.header,
              ...(!tabs
                ? styles.headerWithNoTabs
                : {})
            }}
          >
            {/* Left */}
            <div style={styles.leftSection}>
              {handleRemoveBtnClick &&
                isMobileApp() &&
                !iconButtons.find(
                  (btn) =>
                    Object.prototype.hasOwnProperty.call(
                      btn,
                      "label"
                    ) &&
                    btn.label.includes("Remove")
                ) && (
                  <span
                    className="viewpage-back-btn"
                    role="button"
                    aria-label="Back"
                    style={styles.backButton}
                    onClick={
                      handleRemoveBtnClick
                    }
                  >
                    <Icon type="leftarrow" />
                  </span>
                )}

              {highLightFirstLetter && (
                <div style={styles.avatar}>
                  {highLightFirstLetter}
                </div>
              )}
              {name && (
                <div style={styles.nameWrapper}>
                  {isMobileApp() ? (
                    <h2 style={styles.mobileTitle} title={name}>
                      {name}
                    </h2>
                  ) : (
                    <h1 style={styles.desktopTitle} title={name}>
                      {name}
                    </h1>
                  )}
                </div>
              )}
            </div>

            {/* Right */}
            <div style={styles.rightSection}>
              {!isMobileApp() &&
                this.renderIconButtons()}

              {handleEditBtnClick &&
                !iconButtons.find(
                  (btn) =>
                    Object.prototype.hasOwnProperty.call(
                      btn,
                      "label"
                    ) &&
                    btn.label.includes("Edit")
                ) && (
                  <NewImageButton
                    onClick={handleEditBtnClick}
                    label="Edit"
                    type="edit"
                  />
                )}

              {moreBtn && <span>{moreBtn}</span>}

              {handleDeleteBtnClick &&
                !iconButtons.find(
                  (btn) =>
                    Object.prototype.hasOwnProperty.call(
                      btn,
                      "label"
                    ) &&
                    btn.label.includes("Delete")
                ) && (
                  <NewImageButton
                    onClick={handleDeleteBtnClick}
                    label="Delete"
                    type="delete"
                  />
                )}

              {handleRemoveBtnClick &&
                !isMobileApp() &&
                !iconButtons.find(
                  (btn) =>
                    Object.prototype.hasOwnProperty.call(
                      btn,
                      "label"
                    ) &&
                    btn.label.includes("Remove")
                ) && (
                  <span
                    style={
                      styles.removeButton
                    }
                    onClick={
                      handleRemoveBtnClick
                    }
                  >
                    <Icon type="remove" />
                  </span>
                )}
            </div>
          </div>
        )}

        {customHeader && (
          <span style={styles.customHeader}>
            {customHeader}
          </span>
        )}

        {/* Description - MOVED HERE, outside the header div */}
        {description && (
          <div style={styles.description}>
            {description}
          </div>
        )}

        {tabs && (
          <div style={styles.tabsWrapper}>
            {tabs}
          </div>
        )}
      </div>

      {/* Main Content */}
      <div style={styles.contentWrapper}>
        <div
          style={{
            ...styles.content,
            ...(backgroundColor
              ? {
                background:
                  backgroundColor
              }
              : {})
          }}
        >
          {children}
        </div>
      </div>

      {/* Mobile Floating Menu */}
      {isMobileApp() &&
        iconButtons.length > 0 && (
          <>
            {showMobileOptions && (
              <ActionSheet
                title={name}
                items={iconButtons.map((button) => ({
                  label: button.label,
                  icon: button.icon,
                  danger: /\b(delete|remove)\b/i.test(button.label),
                  onClick: () => {
                    if (typeof button.onClick === "function") {
                      button.onClick();
                    }
                  }
                }))}
                onClose={() =>
                  this.setState({ showMobileOptions: false })
                }
              />
            )}

            <div style={styles.floatingWrapper}>
              <span className="mobile-fab">
                <NewImageButton
                  onClick={() =>
                    this.setState({ showMobileOptions: true })
                  }
                  icon="option"
                />
              </span>
            </div>
          </>
        )}
    </div>
  );
}
}

export default ViewPage;